
























































import Vue from "vue";

// Model
import { formatCurrency } from "@/utility/Formatter.js";
import { BagsCashReportEntry } from "@/model/data/bagsCashReport/BagsCashReportEntry";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";

export default Vue.extend({
    data() {
        return {
            CashTypeEnum,
            headers: [
                { text: this.$t("bagsCashReport.bagCashInPieces"), value: "bagCashInPieces", sortable: false },
                { text: this.$t("bagsCashReport.bagCashInValue"), value: "bagCashInValue", sortable: false, align: "end" },
            ],
        };
    },
    props: {
        loading: { type: Boolean, default: false },
        bagsCashReportEntries: { type: Array as () => BagsCashReportEntry[] },
        isTotalsTable: { type: Boolean, default: false },
    },
    computed: {
        computedHeaders() {
            let res = [];
            if (!this.isTotalsTable) {
                res.push({ text: this.$t("common.installationName"), value: "installationName" });
                res.push({ text: this.$t("common.machineSerialNumber"), value: "machineSerialNumber" });
            }
            this.headers.forEach((h) => {
                res.push(h);
            });
            if (!this.isTotalsTable) {
                res.push({ text: "", value: "actions", align: "center", sortable: false });
            }
            return res;
        },
    },
    methods: { formatCurrency },
});
